exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-lpdp__agrupado,.checkbox_wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row}.checkbox-lpdp__texto-confirmacion{line-height:24px}.checkbox-lpdp__texto-direccion{color:#1973b8;font-weight:700;cursor:pointer}.checkbox-lpdp__responsive{vertical-align:top}.checkbox,.input-control,.radio{width:50px;height:50px}.input-control__box{pointer-events:auto!important;cursor:pointer!important;color:#121212!important}.bloque-lpdp__modal-style{position:relative;border:none;height:75vh}@media (min-width:800px){.checkbox-lpdp__responsive{width:24px}.bloque-lpdp__modal-style{width:60vw;height:75vh}}.styles_modal__gNwvD{max-width:none;padding-right:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/PoliticaPrivacidadCheckbox.css
// module id = 619
// module chunks = 8 9